import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import styled from 'styled-components/native';

export const CloseButton = styled.TouchableOpacity`
  height: ${RFValue(30)}px;
  width: ${RFValue(30)}px;
  position: absolute;
  top: ${RFValue(4)}px;
  right: ${RFValue(4)}px;
  z-index: 1;
  justify-content: center;
  align-items: center;
`;

export const CloseButtonIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(18)}px;
`;
